import React from "react"
import { CartComponent } from "../components"

export default function Cart() {
  return <CartComponent />
}